import React, { useEffect, useState } from "react";
import ModalBox from "../../../components/modal/ModalBox";
import { cashConverter } from "../../../components/Form";
import { Button } from "../../../components/Button/Button";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../../comman/Message";
import {
  fundRequestDetailsApi,
  requestActionApi,
} from "../../../services/resource";

const FundRequestModal = ({ show, close, id, listing }) => {
  const [declineRequestModal, setDeclineRequestModal] = useState(false);
  const [paidRequestModal, setPaidRequestModal] = useState(false);
  const [fundRequestDetails, setFundRequestDetails] = useState("");
  const [value, setValue] = useState("");

  // console.log("fundRequestDetails", fundRequestDetails)
  //--------decline-Request-modal-------------
  const declineRequest = () => {
    setDeclineRequestModal(true);
    setValue("declineRequest");
  };
  //--------paid-To-Resource-modal-------------
  const paidToResource = () => {
    setPaidRequestModal(true);
    setValue("paidResource");
  };
  //----------decline-request----Paid-to-resource---------------
  const fundRequest = async () => {
    try {
      const data = {
        aidId: id,
        status: value === "declineRequest" ? "reject" : "accept",
      };
      const res = await requestActionApi(data);
      if (res?.data?.status === 200) {
        if (value === "declineRequest") {
          setDeclineRequestModal(false);
          close();
        } else {
          setPaidRequestModal(false);
          close();
        }
        successMessage(res);
        listing();
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };

  //------------fund-request-detail--------------
  useEffect(() => {
    const fathFundRequestDetails = async () => {
      if (id) {
        try {
          const res = await fundRequestDetailsApi(id);
          if (res?.data?.status === 200) {
            // console.log("fundDetail", res?.data?.data?.aidDetails)
            setFundRequestDetails(res?.data?.data?.aidDetails);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    fathFundRequestDetails();
  }, [id]);
  console.log(fundRequestDetails,"user")
  return (
    <>
      <ModalBox
        status={show}
        onClose={close}
        // title={"Requested Details"}
        custom
        size="md"
        customizedFooter={
          <button className="btn_size" onClick={close}>
            Close
          </button>
        }
      >
        {/* <hr /> */}
        <div className="row ">
          <div className="col-6">
            <h4>Funds Request</h4>
          </div>
          <div className="col-6 d-flex justify-content-end">
            <Button className="mx-3" onClick={declineRequest}>
              Decline request
            </Button>
            <Button onClick={paidToResource}>Paid to resource</Button>
          </div>
        </div>
        <div className="customer_details">
          <div className="innner">
            <div className="row">
              <div className="col-6">
                <ul>
                 <li>
                    <strong>Name</strong>
                    <span>: {fundRequestDetails?.userId?.name || "N/A"}</span>
                  </li>
                  <li>
                    <strong>User name</strong>
                    <span>: {fundRequestDetails?.userId?.userName || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Email address</strong>
                    <span>: {fundRequestDetails?.userId?.email || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Fund requested</strong>
                    <span>
                      : {cashConverter(fundRequestDetails?.amount) || "N/A"}
                    </span>
                  </li>
                  <li>
                    <strong>Need</strong>
                    <span>: {fundRequestDetails?.need || "N/A"}</span>
                  </li>

                  <li>
                    <strong> Current Income
                    </strong>
                    <span>: {fundRequestDetails?.currentIncome || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Current Challenges
                    </strong>
                    <span>: {fundRequestDetails?.currentChallenges || "N/A"}</span>
                  </li>
                </ul>
              </div>
              <div className="col-6">
                <ul>
                  {/* <li>
                          <strong>Mobile Number</strong>
                                    <span>: {fundRequestDetails?.userId?.mobile ? `${fundRequestDetails?.userId?.countryCode} ${fundRequestDetails?.userId?.mobile}` : "N/A"}</span>
                                    </li> */}
              
                  <li>
                    <strong>Financial Situation</strong>
                    <span>: {fundRequestDetails?.financialSituation || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Goals and Aspirations</strong>
                    <span>: {fundRequestDetails?.goals || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Expected Benefits</strong>
                    <span>: {fundRequestDetails?.expectedBenefits || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Your Story</strong>
                    <span>: {fundRequestDetails?.story || "N/A"}</span>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </ModalBox>
      {/* --------Decline-Request--------- */}
      <ModalBox
        status={declineRequestModal}
        onClose={() => setDeclineRequestModal(false)}
        title="Decline Request"
        description="Are you sure want to decline this Request"
        action={fundRequest}
      />
      {/* --------Paid-Resource--------- */}
      <ModalBox
        status={paidRequestModal}
        onClose={() => setPaidRequestModal(false)}
        title="Paid Resource"
        description="Are you sure want to Paid this Resource"
        action={fundRequest}
      />
    </>
  );
};

export default FundRequestModal;
